import {
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  Frame1e7t2kcdb3wu7 as Frame,
  RowOrCol3a33s3yce2tuv as RowOrCol,
} from '../views/direct/ContainingView.commonHtml.mjs';
import { get_centered1xfu6or5nc0lq as get_centered } from '../views/helpers.mjs';
import {
  h13uhe3f4owggow as h1,
  text1v7b2bj2gx49v as text,
} from '../views/direct/shortcuts.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Page1o437w9xuocrm as Page } from './Page.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  asSequence2phdjljfh9jhx as asSequence,
  getOrNull1go7ef9ldk0df as getOrNull,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  mapNotNull3b8ce5hky4k2l as mapNotNull,
  firstOrNull175qkyx53x0vd as firstOrNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/sequences/_Sequences.mjs';
import { LogRoot_getInstance3817ahbflvs01 as LogRoot_getInstance } from '../debugger.js.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { emptyMapr06gerzljqtm as emptyMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { charArrayOf27f4r3dozbrk1 as charArrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import {
  split3d3yeauc4rm2n as split,
  isBlank1dvkhjjvox3p0 as isBlank,
  trimStart1mkod6gyztuyy as trimStart,
  substringBefore3n7kj60w69hju as substringBefore,
  substringAfter1hku067gwr5ve as substringAfter,
  split2bvyvnrlcifjv as split_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var Routes$1Class;
function Routes$1() {
  if (Routes$1Class === VOID) {
    class $ {
      constructor() {
        this.vd6_1 = _Constant___init__impl__v45mub('Not Found');
      }
      wd6() {
        return this.vd6_1;
      }
      ucv() {
        return new (Constant())(this.wd6());
      }
      ud6(_this__u8e3s4) {
        // Inline function 'kotlin.run' call
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (Frame())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        var tmp = get_centered(view);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        view_0.xbm(true);
        h1(view_0, 'Not Found');
        text(view_0, "Sorry, we couldn't find the page you're looking for.");
        view.fbb(p_0, view_0);
        view.jbb(tmp, view_0);
        _this__u8e3s4.fbb(p, view);
        return view;
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Page()]);
    Routes$1Class = $;
  }
  return Routes$1Class;
}
var RoutesClass;
function Routes() {
  if (RoutesClass === VOID) {
    class $ {
      constructor(parsers, renderers, fallback) {
        var tmp;
        if (fallback === VOID) {
          tmp = new (Routes$1())();
        } else {
          tmp = fallback;
        }
        fallback = tmp;
        this.kbw_1 = parsers;
        this.lbw_1 = renderers;
        this.mbw_1 = fallback;
      }
      nbw(screen) {
        var tmp0_safe_receiver = this.lbw_1.p3(getKClassFromExpression(screen));
        return tmp0_safe_receiver == null ? null : tmp0_safe_receiver(screen);
      }
      xd6(path) {
        var tmp = asSequence(this.kbw_1);
        return firstOrNull(mapNotNull(tmp, (it) => it(path)));
      }
      yd6(path) {
        var tmp;
        try {
          var tmp0_elvis_lhs = this.xd6(path);
          tmp = tmp0_elvis_lhs == null ? this.mbw_1 : tmp0_elvis_lhs;
        } catch ($p) {
          var tmp_0;
          if ($p instanceof Exception()) {
            var e = $p;
            LogRoot_getInstance().gcv(['Encountered exception when parsing route: ' + e.toString()]);
            tmp_0 = this.mbw_1;
          } else {
            throw $p;
          }
          tmp = tmp_0;
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'Routes');
    RoutesClass = $;
  }
  return RoutesClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        // Inline function 'kotlin.collections.listOf' call
        var tmp_0 = emptyList();
        // Inline function 'kotlin.collections.mapOf' call
        var tmp$ret$1 = emptyMap();
        tmp.zd6_1 = new (UrlLikePath())(tmp_0, tmp$ret$1);
      }
      ad7(pathname, search) {
        // Inline function 'kotlin.collections.filter' call
        var tmp0 = split(pathname, charArrayOf([_Char___init__impl__6a9atx(47)]));
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList().w();
        var _iterator__ex2g4s = tmp0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          // Inline function 'kotlin.text.isNotBlank' call
          if (!isBlank(element)) {
            destination.v(element);
          }
        }
        var tmp = destination;
        // Inline function 'kotlin.collections.filter' call
        var tmp0_0 = split(trimStart(search, charArrayOf([_Char___init__impl__6a9atx(63)])), charArrayOf([_Char___init__impl__6a9atx(38)]));
        // Inline function 'kotlin.collections.filterTo' call
        var destination_0 = ArrayList().w();
        var _iterator__ex2g4s_0 = tmp0_0.m1();
        while (_iterator__ex2g4s_0.n1()) {
          var element_0 = _iterator__ex2g4s_0.o1();
          // Inline function 'kotlin.text.isNotBlank' call
          if (!isBlank(element_0)) {
            destination_0.v(element_0);
          }
        }
        // Inline function 'kotlin.collections.associate' call
        var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(destination_0, 10)), 16);
        // Inline function 'kotlin.collections.associateTo' call
        var destination_1 = LinkedHashMap().fc(capacity);
        var _iterator__ex2g4s_1 = destination_0.m1();
        while (_iterator__ex2g4s_1.n1()) {
          var element_1 = _iterator__ex2g4s_1.o1();
          // Inline function 'kotlin.collections.plusAssign' call
          var pair = to(substringBefore(element_1, _Char___init__impl__6a9atx(61)), decodeURIComponent(substringAfter(element_1, _Char___init__impl__6a9atx(61))));
          destination_1.s3(pair.af_1, pair.bf_1);
        }
        return new (UrlLikePath())(tmp, destination_1);
      }
      bd7(url) {
        var parts = split_0(url, ['?']);
        var tmp0_elvis_lhs = getOrNull(parts, 0);
        var tmp = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
        var tmp1_elvis_lhs = getOrNull(parts, 1);
        return this.ad7(tmp, tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function UrlLikePath$render$lambda(it) {
  return it.e2() + '=' + encodeURIComponent(it.f2());
}
var UrlLikePathClass;
function UrlLikePath() {
  if (UrlLikePathClass === VOID) {
    class $ {
      constructor(segments, parameters) {
        Companion_getInstance();
        this.qbw_1 = segments;
        this.rbw_1 = parameters;
      }
      sbw() {
        var tmp = joinToString(this.qbw_1, '/');
        // Inline function 'kotlin.takeUnless' call
        var this_0 = this.rbw_1;
        var tmp_0;
        if (!this_0.i1()) {
          tmp_0 = this_0;
        } else {
          tmp_0 = null;
        }
        var tmp0_safe_receiver = tmp_0;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d2();
        var tmp_1;
        if (tmp1_safe_receiver == null) {
          tmp_1 = null;
        } else {
          tmp_1 = joinToString(tmp1_safe_receiver, '&', '?', VOID, VOID, VOID, UrlLikePath$render$lambda);
        }
        var tmp2_elvis_lhs = tmp_1;
        return tmp + (tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs);
      }
      cd7(segments, parameters) {
        return new (UrlLikePath())(segments, parameters);
      }
      dd7(segments, parameters, $super) {
        segments = segments === VOID ? this.qbw_1 : segments;
        parameters = parameters === VOID ? this.rbw_1 : parameters;
        return $super === VOID ? this.cd7(segments, parameters) : $super.cd7.call(this, segments, parameters);
      }
      toString() {
        return 'UrlLikePath(segments=' + toString(this.qbw_1) + ', parameters=' + toString(this.rbw_1) + ')';
      }
      hashCode() {
        var result = hashCode(this.qbw_1);
        result = imul(result, 31) + hashCode(this.rbw_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof UrlLikePath()))
          return false;
        if (!equals(this.qbw_1, other.qbw_1))
          return false;
        if (!equals(this.rbw_1, other.rbw_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'UrlLikePath');
    UrlLikePathClass = $;
  }
  return UrlLikePathClass;
}
var RouteRenderedClass;
function RouteRendered() {
  if (RouteRenderedClass === VOID) {
    class $ {
      constructor(urlLikePath, listenables) {
        this.obw_1 = urlLikePath;
        this.pbw_1 = listenables;
      }
      toString() {
        return 'RouteRendered(urlLikePath=' + this.obw_1.toString() + ', listenables=' + toString(this.pbw_1) + ')';
      }
      hashCode() {
        var result = this.obw_1.hashCode();
        result = imul(result, 31) + hashCode(this.pbw_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof RouteRendered()))
          return false;
        if (!this.obw_1.equals(other.obw_1))
          return false;
        if (!equals(this.pbw_1, other.pbw_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'RouteRendered');
    RouteRenderedClass = $;
  }
  return RouteRenderedClass;
}
function render(_this__u8e3s4, writer) {
  // Inline function 'kotlin.with' call
  return _this__u8e3s4.ud6(writer);
}
//region block: exports
export {
  RouteRendered as RouteRendered1fij9e8c6nzoq,
  Routes as Routesboifombvgcz7,
  UrlLikePath as UrlLikePath1l4lcedbwd0yq,
  render as render38qn7o0b2bza2,
  Companion_getInstance as Companion_getInstance3qvaw4651ntmp,
};
//endregion

//# sourceMappingURL=Routes.mjs.map
